import { aspenApi as api, newFixedProductsList } from "@aspen/services";
import { generateDataCacheKey, loadData } from "@aspen/libs";
import { useQuery } from "@tanstack/react-query";
import type { IReqFixedProductsList, IYieldNewFixedListRes } from "@aspen/model";
import { useUpdateQueryCache } from "./useUpdateQueryCache";

/**
 * 获取定期产品列表。
 * @param {IReqFixedProductsList} params - 获取定期产品列表所需的参数。
 */
// ADGM没有开放理财功能。暂时没有测试场景。
export const useFetchFixedYieldList = (params: IReqFixedProductsList) => {
  const apiPath = api.savings.newFixed.productList;
  const queryKey = generateDataCacheKey({ api: apiPath, params: JSON.stringify(params) });
  const cacheData = loadData<IYieldNewFixedListRes>(queryKey)?.data;

  const { error, data, isLoading, refetch, isPlaceholderData } = useQuery({
    queryKey: [queryKey, Object.values(params)],
    queryFn: () => {
      return newFixedProductsList(params).then(res => {
        return res.data;
      });
    },
    placeholderData: cacheData,
  });
  useUpdateQueryCache(queryKey, data, cacheData, isPlaceholderData);
  return { error, data, refetch, queryKey, isLoading };
};
